<template>
  <mdb-container fluid>
    <!-- Section: Grid -->
    <section style="height: calc(100vh - 117px);">
      <ejs-grid
        ref="grid"
        locale="de"
        height="100%"
        :dataSource="dataSource"
        :dataBound="dataBound"
        :toolbar="toolbar"
        :toolbarClick="clickToolbar"
        :allowGrouping="true"
        :groupSettings="groupSettings"
        :allowSorting="true"
        :sortSettings="sortSettings"
        :selectionSettings="selectionOptions"
        :rowSelected="onRowSelected"
        :rowDeselected="onRowDeselected"
        :recordDoubleClick="recordDoubleClick"
        :editSettings="editSettings"
        :queryCellInfo="queryCellInfo"
        :actionComplete="actionComplete"
      >
        <e-columns>
          <e-column
            type="checkbox"
            width="50"
          ></e-column>
          <e-column
            field="id"
            headerText="ID"
            textAlign="Left"
            :isPrimaryKey="true"
            :visible="false"
          ></e-column>
          <e-column
            field="reference"
            headerText="Kd. Nr."
            textAlign="Left"
          ></e-column>
          <e-column
            field="company"
            headerText="Firma"
            textAlign="Left"
          ></e-column>
          <e-column
            field="first_name"
            headerText="Vorname"
            textAlign="Left"
            :visible="false"
          ></e-column>
          <e-column
            field="last_name"
            headerText="Nachname"
            textAlign="Left"
            :visible="false"
          ></e-column>
          <e-column
            field="full_name"
            headerText="Teilnehmer"
            textAlign="Left"
            :customAttributes="labelColumnAttributes"
          ></e-column>
          <e-column
            field="segment"
            headerText="Gruppe"
            textAlign="Left"
            :disableHtmlEncode="false"
          ></e-column>
          <e-column
            field="consultant"
            headerText="Mitarbeiter"
            textAlign="Left"
            :disableHtmlEncode="false"
          ></e-column>
          <e-column
            field="memo"
            headerText="<i class='fas fa-comment' data-toggle='tooltip' data-placement='top' title='Kommentar'></i>"
            textAlign="Left"
            :disableHtmlEncode="false"
          ></e-column>
          <e-column
            field="invited_date"
            headerText="Eingeladen"
            textAlign="Center"
            width="165"
          ></e-column>
          <e-column
            field="confirmed_date"
            headerText="Rückmeldung"
            textAlign="Center"
            width="165"
          ></e-column>
          <e-column
            field="invited"
            headerText="<i class='e-btn-icon e-icon-chevron-right-double e-icons e-icon-left table-header-icon' data-toggle='tooltip' data-placement='top' title='Einladung versendet'></i>"
            textAlign="Left"
            :disableHtmlEncode="false"
            width="41"
            :customAttributes="statusColumnAttributes"
          ></e-column>
          <e-column
            field="confirmed"
            headerText="<i class='e-btn-icon e-icon-check-box e-icons e-icon-left table-header-icon' data-toggle='tooltip' data-placement='top' title='Zusage/Absage'></i>"
            textAlign="Left"
            :disableHtmlEncode="false"
            width="41"
            :customAttributes="statusColumnAttributes"
          ></e-column>
          <e-column
            field="authorized"
            headerText="<i class='e-btn-icon e-icon-display-for-review e-icons e-icon-left table-header-icon' data-toggle='tooltip' data-placement='top' title='Ticket versendet'></i>"
            textAlign="Left"
            :disableHtmlEncode="false"
            width="41"
            :customAttributes="statusColumnAttributes"
          ></e-column>
          <e-column
            field="visited"
            headerText="<i class='fas fa-user-check' data-toggle='tooltip' data-placement='top' title='Teilnehmer erschienen'></i>"
            textAlign="Left"
            :disableHtmlEncode="false"
            width="41"
            :customAttributes="statusColumnAttributes"
          ></e-column>
          <e-column
            field="notification"
            headerText="<i class='e-btn-icon e-icon-circle-info e-icons e-icon-left table-header-icon' data-toggle='tooltip' data-placement='top' title='SMS Benachrichtigung'></i>"
            textAlign="Left"
            :disableHtmlEncode="false"
            width="41"
            :customAttributes="statusColumnAttributes"
          ></e-column>
        </e-columns>
      </ejs-grid>
    </section>
    <!-- /Section: Grid -->
    <!-- Modal: Participant -->
    <mdb-modal
      centered
      size="lg"
      scrollable
      removeBackdrop
      :show="showModal"
      @close="closeModal"
    >
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title v-if="modalEdit">Teilnehmer bearbeiten</mdb-modal-title>
        <mdb-modal-title v-else>Teilnehmer hinzufügen</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <form id="modal-form" novalidate @submit.prevent="saveModal" @keydown.enter.prevent>
          <mdb-row>
            <mdb-col md="6" class="mb-3" style="border-right: 1px solid #aaa;">
              <legend><mdb-icon icon="user" class="blue-text" /> Ansprechpartner</legend>
              <input type="hidden" v-model="model.id">
              <mdb-input
                label="Firma"
                type="text"
                class="mb-3 mt-3"
                v-model="model.company"
                required
              />
              <mdb-select
                label="Anrede"
                class="mt-3 mb-0"
                v-model="model.title"
                ref="title"
                validation
              />
              <mdb-input
                label="Titel"
                type="text"
                class="mt-0 mb-3"
                v-model="model.title_honorific"
              />
              <mdb-input
                label="Vorname"
                type="text"
                class="mb-3 mt-3"
                v-model="model.first_name"
                required
              />
              <mdb-input
                label="Nachname"
                type="text"
                class="mb-3 mt-3"
                v-model="model.last_name"
                required
              />
              <legend><mdb-icon icon="map-marked-alt" class="blue-text mt-4" /> Anschrift</legend>
              <mdb-input
                label="Straße"
                type="text"
                class="mb-3 mt-3"
                v-model="model.street"
              />
              <mdb-input
                label="PLZ"
                type="text"
                class="mb-3 mt-3"
                v-model="model.zip"
              />
              <mdb-input
                label="Stadt"
                type="text"
                class="mb-3 mt-3"
                v-model="model.city"
              />
              <mdb-input
                label="Region"
                type="text"
                class="mb-3 mt-3"
                v-model="model.region"
              />
              <mdb-input
                label="Land"
                type="text"
                class="mb-3 mt-3"
                v-model="model.country"
              />
            </mdb-col>
            <mdb-col md="6" class="mb-3">
              <legend><mdb-icon icon="phone" class="blue-text" /> Kontakt</legend>
              <mdb-input
                label="Telefon"
                type="text"
                class="mb-3 mt-3"
                v-model="model.phone"
              />
              <mdb-input
                label="Mobil"
                type="text"
                class="mb-3 mt-3"
                v-model="model.mobile"
              />
              <mdb-input
                label="Fax"
                type="text"
                class="mb-3 mt-3"
                v-model="model.fax"
              />
              <mdb-input
                label="E-Mail"
                type="text"
                class="mb-3 mt-3"
                v-model="model.email"
                required
              />
              <legend><mdb-icon icon="cog" class="blue-text mt-4" /> Sonstiges</legend>
              <mdb-select
                label="Gruppe"
                class="my-0 mt-3 mb-0"
                v-model="model.segment"
                ref="segment"
                validation
                search
              />
              <mdb-select
                label="Mitarbeiter"
                class="my-0 mt-3 mb-0"
                v-model="model.consultant"
                ref="consultant"
                validation
                search
              />
              <mdb-input
                label="Kundennummer"
                type="text"
                class="mb-3"
                v-model="model.reference"
              />
              <mdb-input
                label="Check-in SMS Empfänger"
                type="text"
                class="mb-3"
                v-model="model.notification"
              />
              <legend><mdb-icon icon="comment" class="blue-text mt-4" /> Anmerkung</legend>
              <vue-editor
                id="memoEditor"
                v-model="model.memo"
                :editor-toolbar="editorToolbar"
              />
            </mdb-col>
          </mdb-row>
        </form>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn outline="blue" @click.native="closeModal">Abbrechen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true" v-if="modalEdit">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Speichern
        </mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true" v-else>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Hinzufügen
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: Participant -->
    <!-- Modal: Delete -->
    <mdb-modal :show="showDelete" @close="showDelete = false">
      <mdb-modal-header color="red">
        <mdb-modal-title>Teilnehmer löschen</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="3" class="mb-3">
            <mdb-icon icon="ban" size="4x" class="red-text ml-3"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              <strong>Wollen Sie die folgenden Teilnehmer wirklich löschen?</strong>
            </p>
            <mdb-card>
              <mdb-card-body>
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <ul>
                    <li v-for="(record) in selectedRecords.slice(0, 5)" :key="record.full_name">
                      {{ record.full_name }}
                    </li>
                    <br>
                    <p v-show="selectedRecords.length > 5">... und <b>{{ selectedRecords.length - 5 }}</b> weitere.</p>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="red" @click="showDelete = false">Abbrechen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="red" :disabled="loading === true" @click.native="deleteRecord">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Löschen
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: Delete -->
    <!-- Modal: Segment -->
    <mdb-modal :show="showSegment" @close="showSegment = false">
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title>Gruppe zuweisen</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="3" class="mb-3">
            <mdb-icon icon="tag" size="4x" class="grey-text"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              <strong>Wollen Sie die gewählten Teilnehmer mit folgender Gruppe verknüpfen?</strong>
            </p>
            <mdb-card>
              <mdb-card-body class="pb-0">
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <mdb-select
                    label="Gruppe"
                    class="mt-3"
                    v-model="model.segment"
                    ref="bulk_segment"
                    search
                  />
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="mt-4">
              <mdb-card-body>
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <ul>
                    <li v-for="(record) in selectedRecords.slice(0, 5)" :key="record.full_name">
                      {{ record.full_name }}
                    </li>
                    <br>
                    <p v-show="selectedRecords.length > 5">... und <b>{{ selectedRecords.length - 5 }}</b> weitere.</p>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="blue" @click="showSegment = false">Abbrechen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true" @click.native="segmentEntry">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Zuweisen
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: Segment -->
    <!-- Modal: Consultant -->
    <mdb-modal :show="showConsultant" @close="showConsultant = false">
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title>Mitarbeiter zuweisen</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="3" class="mb-3">
            <mdb-icon icon="tag" size="4x" class="grey-text"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              <strong>Wollen Sie die gewählten Teilnehmer mit folgendem Mitarbeiter verknüpfen?</strong>
            </p>
            <mdb-card>
              <mdb-card-body class="pb-0">
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <mdb-select
                    label="Mitarbeiter"
                    class="mt-3"
                    v-model="model.consultant"
                    ref="bulk_consultant"
                    search
                  />
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="mt-4">
              <mdb-card-body>
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <ul>
                    <li v-for="(record) in selectedRecords.slice(0, 5)" :key="record.full_name">
                      {{ record.full_name }}
                    </li>
                    <br>
                    <p v-show="selectedRecords.length > 5">... und <b>{{ selectedRecords.length - 5 }}</b> weitere.</p>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="blue" @click="showConsultant = false">Abbrechen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true" @click.native="consultEntry">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Zuweisen
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: Consultant -->
    <!-- Modal: notifyRecords -->
    <mdb-modal :show="showNotifyRecords" @close="showNotifyRecords = false">
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title>Check-in SMS Empfänger zuweisen</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="3" class="mb-3">
            <mdb-icon icon="tag" size="4x" class="grey-text"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              <strong>Wollen Sie die gewählten Teilnehmer mit folgender Mobilfunknummer verknüpfen?</strong>
            </p>
            <mdb-card>
              <mdb-card-body class="pb-0">
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <mdb-input
                    label="Check-in SMS Empfänger"
                    type="text"
                    class="mb-3 mt-3"
                    v-model="model.notification"
                  />
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="mt-4">
              <mdb-card-body>
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <ul>
                    <li v-for="(record) in selectedRecords.slice(0, 5)" :key="record.full_name">
                      {{ record.full_name }}
                    </li>
                    <br>
                    <p v-show="selectedRecords.length > 5">... und <b>{{ selectedRecords.length - 5 }}</b> weitere.</p>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="blue" @click="showNotifyRecords = false">Abbrechen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true" @click.native="notifyRecords">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Zuweisen
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: notifyRecords -->
    <!-- Modal: inviteRecords -->
    <mdb-modal
      size="lg"
      scrollable
      removeBackdrop
      :show="showInviteRecords"
      @close="showInviteRecords = false"
    >
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title>Einladung senden</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="2" class="mb-3">
            <mdb-icon icon="envelope" far size="4x" class="blue-text ml-4"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              Wählen sie eine Gruppe an Teilnehmern aus, die eine Einladung per E-Mail erhalten sollen:
            </p>
            <mdb-input type="radio" id="invite-option-1" name="inviteOptions" radioValue="selection" v-model="activeRecords.scope" :disabled="selectedRecords.length === 0" class="mb-2" label="Ihre Auswahl" />
            <mdb-input type="radio" id="invite-option-2" name="inviteOptions" radioValue="pending_invitation" v-model="activeRecords.scope" class="mb-2" label="Alle Teilnehmer, die noch keine Einladung erhalten haben" />
            <mdb-input type="radio" id="invite-option-3" name="inviteOptions" radioValue="pending_invitation_reminder" v-model="activeRecords.scope" class="mb-2" label="Alle eingeladenen Teilnehmer ohne Rückmeldung (Reminder)" />
            <mdb-card class="mt-4" v-show="activeRecords.scope === 'selection'">
              <mdb-card-body>
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <div class="mb-2 pl-4">Ausgewählte Teilnehmer:</div>
                  <ul class="mb-0">
                    <li v-for="(record) in selectedRecords.slice(0, 5)" :key="record.id">
                      {{ record.full_name }}
                    </li>
                    <br>
                    <p v-show="selectedRecords.length > 5">... und <b>{{ selectedRecords.length - 5 }}</b> weitere.</p>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="mt-4">
              <mdb-card-body>
                <mdb-card-title class="text-muted">Warteschlange</mdb-card-title>
                <mdb-card-text>
                  <mdb-progress :value="activeRecordsProgress" :height="20" />
                  <p>{{ activeRecords.processed }} von {{ activeRecords.total }} Einladungen versendet</p>
                  <p v-show="activeRecords.complete === true" class="green-text">Versand abgeschlossen, Sie können den Dialog jetzt schließen</p>
                  <p v-show="activeRecords.failed.length === 1" class="red-text">{{ activeRecords.failed.length }} Einladung konnte nicht versendet werden</p>
                  <p v-show="activeRecords.failed.length > 1" class="red-text">{{ activeRecords.failed.length }} Einladungen konnten nicht versendet werden</p>
                  <ul v-show="activeRecords.failed.length > 0" class="red-text">
                    <li v-for="failed in activeRecords.failed" :key="failed.id">
                      E-Mail: {{ failed.label }}
                    </li>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="blue" @click="showInviteRecords = false">Schließen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true || activeRecords.total === 0 || activeRecords.complete === true" @click.native="processRecords">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Senden
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: inviteRecords -->
    <!-- Modal: registerRecords -->
    <mdb-modal :show="showRegisterRecords" @close="showRegisterRecords = false">
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title>Anmeldestatus ändern</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="3" class="mb-3">
            <mdb-icon icon="check-square" size="4x" class="grey-text"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              <strong>Wollen Sie die Anmeldung der gewählten Teilnehmer mit folgendem Status überschreiben?</strong>
            </p>
            <mdb-card>
              <mdb-card-body class="pb-0">
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <mdb-select
                    label="Status"
                    class="mt-3"
                    v-model="action.register"
                    ref="bulk_register"
                    search
                  />
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="mt-4">
              <mdb-card-body>
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <ul>
                    <li v-for="(record) in selectedRecords.slice(0, 5)" :key="record.full_name">
                      {{ record.full_name }}
                    </li>
                    <br>
                    <p v-show="selectedRecords.length > 5">... und <b>{{ selectedRecords.length - 5 }}</b> weitere.</p>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="blue" @click="showRegisterRecords = false">Abbrechen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true" @click.native="registerRecords">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Ändern
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: registerRecords -->
    <!-- Modal: authorizeRecords -->
    <mdb-modal
      size="lg"
      scrollable
      removeBackdrop
      :show="showAuthorizeRecords"
      @close="showAuthorizeRecords = false"
    >
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title>Ticket senden</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="2" class="mb-3">
            <mdb-icon icon="file-alt" far size="4x" class="blue-text ml-4"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              Wählen sie eine Gruppe an Teilnehmern aus, die ein Ticket per E-Mail erhalten sollen:
            </p>
            <mdb-input type="radio" id="authorize-option-1" name="authorizeOptions" radioValue="selection" v-model="activeRecords.scope" :disabled="this.selectedRecords.length === 0" class="mb-2" label="Ihre Auswahl" />
            <mdb-input type="radio" id="authorize-option-2" name="authorizeOptions" radioValue="pending_authorization" v-model="activeRecords.scope" class="mb-2" label="Alle Zusagen, die noch kein Ticket erhalten haben" />
            <mdb-card class="mt-4" v-show="activeRecords.scope === 'selection'">
              <mdb-card-body>
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <div class="mb-2 pl-4">Ausgewählte Teilnehmer:</div>
                  <ul class="mb-0">
                    <li v-for="(record) in selectedRecords.slice(0, 5)" :key="record.id">
                      {{ record.full_name }}
                    </li>
                    <br>
                    <p v-show="selectedRecords.length > 5">... und <b>{{ selectedRecords.length - 5 }}</b> weitere.</p>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="mt-4">
              <mdb-card-body>
                <mdb-card-title class="text-muted">Warteschlange</mdb-card-title>
                <mdb-card-text>
                  <mdb-progress :value="activeRecordsProgress" :height="20" />
                  <p>{{ activeRecords.processed }} von {{ activeRecords.total }} Tickets versendet</p>
                  <p v-show="activeRecords.complete === true" class="green-text">Versand abgeschlossen, Sie können den Dialog jetzt schließen</p>
                  <p v-show="activeRecords.failed.length === 1" class="red-text">{{ activeRecords.failed.length }} Ticket konnte nicht versendet werden</p>
                  <p v-show="activeRecords.failed.length > 1" class="red-text">{{ activeRecords.failed.length }} Tickets konnten nicht versendet werden</p>
                  <ul v-show="activeRecords.failed.length > 0" class="red-text">
                    <li v-for="failed in activeRecords.failed" :key="failed.id">
                      E-Mail: {{ failed.label }}
                    </li>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="blue" @click="showAuthorizeRecords = false">Schließen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true || activeRecords.total === 0 || activeRecords.complete === true" @click.native="processRecords">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Senden
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: authorizeRecords -->
    <!-- Modal: printAuthorization -->
    <mdb-modal
      size="lg"
      scrollable
      removeBackdrop
      :show="showPrintAuthorization"
      @close="showPrintAuthorization = false"
    >
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title>Ticket drucken</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="2" class="mb-3">
            <mdb-icon icon="print" fas size="4x" class="blue-text ml-4"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              Wollen Sie die Tickets der ausgewählten Teilnehmer drucken?
            </p>
            <p class="red-text font-weight-bold">
              Achtung: Der Status der Teilnehmer wird auf "Ticket versendet" gesetzt.
            </p>
            <mdb-card class="mt-4">
              <mdb-card-body>
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <div class="mb-2 pl-4">Ausgewählte Teilnehmer:</div>
                  <ul class="mb-0">
                    <li v-for="(record) in selectedRecords.slice(0, 5)" :key="record.id">
                      {{ record.full_name }}
                    </li>
                    <br>
                    <p v-show="selectedRecords.length > 5">... und <b>{{ selectedRecords.length - 5 }}</b> weitere.</p>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="blue" @click="showPrintAuthorization = false">Schließen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" @click.native="printAuthorization">
          Drucken
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: printAuthorization -->
    <!-- Modal: transferRecords -->
    <mdb-modal :show="showTransferRecords" @close="showTransferRecords = false">
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title>Teilnehmer übertragen</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="3" class="mb-3">
            <mdb-icon icon="exchange-alt" size="4x" class="grey-text"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              <strong>Wollen Sie die ausgewählten Teilnehmer auf folgende Veranstaltung übertragen?</strong>
            </p>
            <mdb-card>
              <mdb-card-body class="pb-0">
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <mdb-container>
                    <mdb-select v-model="this.action.eventCategoryOptions" @getValue="getEventCategoryValue" label="Veranstaltungsreihe" />
                  </mdb-container>
                  <mdb-container>
                    <mdb-select v-model="this.action.eventYearOptions" @getValue="getEventYearValue" label="Jahr" />
                  </mdb-container>
                  <mdb-container>
                    <mdb-select v-model="this.action.eventLocationOptions" label="Termin" />
                  </mdb-container>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
            <mdb-card class="mt-4">
              <mdb-card-body>
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <ul>
                    <li v-for="(record) in selectedRecords.slice(0, 5)" :key="record.full_name">
                      {{ record.full_name }}
                    </li>
                    <br>
                    <p v-show="selectedRecords.length > 5">... und <b>{{ selectedRecords.length - 5 }}</b> weitere.</p>
                  </ul>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="blue" @click="showTransferRecords = false">Abbrechen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true" @click.native="transferRecords">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Übertragen
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: transferRecords -->
    <!-- Modal: importRecords -->
    <mdb-modal
      centered
      size="lg"
      scrollable
      removeBackdrop
      :show="showImportRecords"
      @close="showImportRecords = false"
    >
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title>Teilnehmerdaten importieren</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="2" class="mb-3">
            <mdb-icon icon="file-import" fas size="4x" class="blue-text ml-4"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              Wählen sie eine Excel-Datei aus die importiert werden soll:
            </p>
            <input type="file" @change="handleFileUpload( $event )"/>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="blue" @click="showImportRecords = false">Abbrechen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true" @click.native="importRecords">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Importieren
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: importRecords -->
    <!-- Modal: exportRecords -->
    <mdb-modal
      centered
      size="lg"
      scrollable
      removeBackdrop
      :show="showExportRecords"
      @shown="exportRecordsShown"
      @close="showExportRecords = false"
    >
      <mdb-modal-header color="cloudy-knoxville-gradient">
        <mdb-modal-title>Teilnehmerdaten exportieren</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-row>
          <mdb-col col="2" class="mb-3">
            <mdb-icon icon="file-export" fas size="4x" class="blue-text ml-4"/>
          </mdb-col>
          <mdb-col col="9" class="mb-2">
            <p class="mb-4">
              Wählen sie eine Gruppe an Teilnehmern aus, deren Daten in eine Excel-Datei exportiert werden soll:
            </p>
            <mdb-input type="radio" id="export-option-1" name="exportOptions" radioValue="confirmed" v-model="action.export" class="mb-2" label="Alle Zusagen" />
            <mdb-input type="radio" id="export-option-2" name="exportOptions" radioValue="cancelled" v-model="action.export" class="mb-2" label="Alle Absagen" />
            <mdb-input type="radio" id="export-option-3" name="exportOptions" radioValue="visited" v-model="action.export" class="mb-2" label="Alle Erschienenen" />
            <mdb-input type="radio" id="export-option-6" name="exportOptions" radioValue="absent" v-model="action.export" class="mb-2" label="Alle Abwesenden" />
            <mdb-input type="radio" id="export-option-4" name="exportOptions" radioValue="deleted" v-model="action.export" class="mb-2" label="Alle Gelöschten (DSGVO)" />
            <mdb-input type="radio" id="export-option-5" name="exportOptions" radioValue="all" v-model="action.export" class="mb-2" label="Alle Teilnehmer" />
            <mdb-card class="mt-4">
              <mdb-card-body>
                <mdb-card-title></mdb-card-title>
                <mdb-card-text>
                  <div class="mb-2 pl-4">Ausgewählte Teilnehmer:</div>
                  <p v-show="this.action.export === 'confirmed'" class="pl-4">{{ exportRecordCount }} Teilnehmer mit Zusage</p>
                  <p v-show="this.action.export === 'cancelled'" class="pl-4">{{ exportRecordCount }} Teilnehmer mit Absage</p>
                  <p v-show="this.action.export === 'visited'" class="pl-4">{{ exportRecordCount }} Teilnehmer zur Veranstaltung erschienen</p>
                  <p v-show="this.action.export === 'absent'" class="pl-4">{{ exportRecordCount }} Teilnehmer abwesend</p>
                  <p v-show="this.action.export === 'deleted'" class="pl-4">{{ exportRecordCount }} Teilnehmer mit Aufforderung zur Löschung</p>
                  <p v-show="this.action.export === 'all'" class="pl-4">{{ exportRecordCount }} Teilnehmer</p>
                </mdb-card-text>
              </mdb-card-body>
            </mdb-card>
          </mdb-col>
        </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn outline="blue" @click="showExportRecords = false">Abbrechen</mdb-btn>
        <mdb-btn type="submit" form="modal-form" color="blue" :disabled="loading === true" @click.native="exportRecords">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading === true"></span>
          Exportieren
        </mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <!-- /Modal: exportRecords -->
  </mdb-container>
</template>

<script>
function clearSelection() {
  if (window.getSelection) {
    window.getSelection().removeAllRanges()
  } else if (document.selection) {
    document.selection.empty()
  }
}

import Vue from 'vue'
import { bus } from '../../main'
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json'
import * as cagregorian from 'cldr-data/main/de/ca-gregorian.json'
import * as numbers from 'cldr-data/main/de/numbers.json'
import * as timeZoneNames from 'cldr-data/main/de/timeZoneNames.json'
import * as weekData from 'cldr-data/supplemental/weekData.json'
import * as currencies from 'cldr-data/main/de/currencies.json'
import { L10n, loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base'
import { GridPlugin, Edit, Toolbar, Resize, Search, Sort, Group } from '@syncfusion/ej2-vue-grids'
import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data'
import axios from 'axios'
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbIcon,
  mdbBtn,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbInput,
  mdbCard,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbSelect,
  mdbProgress
} from 'mdbvue'
import { VueEditor } from "vue2-editor"

L10n.load({
  'de': {
    'grid': {
      'EmptyRecord': 'Keine Einträge gefunden',
      'GroupDropArea': 'Spalte hier ablegen um zu gruppieren',
      'UnGroup': 'Klicken Sie hier, um die Gruppierung aufheben',
      'Item': 'Eintrag',
      'Items': 'Einträge',
      'Search': 'Suche',
      'FilterButton': 'Filtern',
      'ClearButton': 'Löschen',
      'SelectAll': 'Alle',
      'Blanks': 'Leer',
      'Add': 'Hinzufügen',
      'Edit': 'Bearbeiten',
      'Delete': 'Löschen',
      'Enter the value': 'Suchbegriff eingeben'
    },
    'pager': {
      'currentPageInfo': '{0} von {1} Seiten',
      'totalItemsInfo': '({0} Einträge)',
      'firstPageTooltip': 'Zur ersten Seite',
      'lastPageTooltip': 'Zur letzten Seite',
      'nextPageTooltip': 'Zur nächsten Seite',
      'previousPageTooltip': 'Zurück zur letzten Seit',
      'nextPagerTooltip': 'Zum nächsten Pager',
      'previousPagerTooltip': 'Zum vorherigen Pager'
    }
  }
})
loadCldr(numberingSystems, cagregorian, numbers, timeZoneNames, weekData, currencies)
setCulture('de')
setCurrencyCode('EUR')

Vue.use(GridPlugin)

export default {
  name: 'Participants',
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbInput,
    mdbCard,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbSelect,
    mdbProgress,
    VueEditor
  },
  data () {
    return {
      loading: false,
      model: {
        id: 'new',
        timeslot: '',
        consultant: '',
        notification: '',
        reference: '',
        segment: [],
        memo: '',
        company: '',
        title: [
          { text: 'Herr', value: 'Herr', selected: true },
          { text: 'Frau', value: 'Frau', selected: false }
        ],
        title_honorific: '',
        first_name: '',
        last_name: '',
        street: '',
        zip: '',
        city: '',
        region: '',
        country: '',
        phone: '',
        mobile: '',
        fax: '',
        email: ''
      },
      selectedRecords: [],
      activeRecords: {
        endpoint: '',
        selection: [],
        selected: 0,
        model: 'participants',
        scope: 'all',
        target: 'client',
        total: 0,
        processed: 0,
        failed: [],
        complete: false
      },
      action: {
        selection: [],
        register: [
          { text: 'Zusage', value: 'confirm', selected: true },
          { text: 'Absage', value: 'cancel', selected: false },
          { text: 'Zurücksetzen', value: 'reset', selected: false }
        ],
        eventCategoryOptions: [],
        eventYearOptions: [],
        eventLocationOptions: [],
        export: 'confirmed'
      },
      eventCategory: localStorage.getItem('eventCategory'),
      eventYear: localStorage.getItem('eventYear'),
      event: localStorage.getItem('event'),
      username: localStorage.getItem('username'),
      file: '',
      exportRecordCount: 0,
      showModal: false,
      modalEdit: false,
      showDelete: false,
      showSegment: false,
      showConsultant: false,
      showNotifyRecords: false,
      showInviteRecords: false,
      showRegisterRecords: false,
      showAuthorizeRecords: false,
      showPrintAuthorization: false,
      showTransferRecords: false,
      showImportRecords: false,
      showExportRecords: false,
      wasValidated: false,
      dataSource: new DataManager({
        url: Vue.prototype.$serverUrl + 'api/list_participants.php',
        adaptor: new UrlAdaptor,
        crossDomain: true
      }),
      toolbar: [
        { text: 'Hinzufügen', tooltipText: 'Einen Teilnehmer hinzufügen', prefixIcon: 'e-add', id: 'addRecord' },
        { text: 'Bearbeiten', tooltipText: 'Einen Teilnehmer bearbeiten', prefixIcon: 'e-edit', id: 'editRecord' },
        { text: 'Löschen', tooltipText: 'Einen oder mehrere Teilnehmer löschen', prefixIcon: 'e-delete', id: 'deleteRecord' },
        { type: 'Separator' },
        { text: 'Gruppe', tooltipText: 'Teilnehmern eine Gruppe zuweisen', prefixIcon: 'e-icon-bookmark', id: 'segmentRecord' },
        { text: 'Mitarbeiter', tooltipText: 'Teilnehmern einen Mitarbeiter zuweisen', prefixIcon: 'e-icon-resource', id: 'consultRecord' },
        { text: 'SMS', tooltipText: 'Teilnehmern eine Check-in Benachrichtigung per SMS zuweisen', prefixIcon: 'e-icon-circle-info', id: 'notifyRecords' },
        { type: 'Separator' },
        { text: 'Einladung', tooltipText: 'Einladungen an Teilnehmer versenden', prefixIcon: 'e-icon-chevron-right-double', id: 'inviteRecords' },
        { text: 'Anmeldestatus', tooltipText: 'Status der Anmeldung ändern', prefixIcon: 'e-icon-check-box', id: 'registerRecords' },
        { text: 'Ticket senden', tooltipText: 'Eintritts-Tickets an Teilnehmer versenden', prefixIcon: 'e-icon-display-for-review', id: 'authorizeRecords' },
        { text: 'Ticket drucken', tooltipText: 'Eintritts-Tickets drucken', prefixIcon: 'e-icon-print-2', id: 'printAuthorization' },
        { type: 'Separator' },
        { text: 'Übertragen', tooltipText: 'Teilnehmer auf andere Veranstaltungen übertragen', prefixIcon: 'e-icon-redo-2', id: 'transferRecords' },
        { text: 'Import', tooltipText: 'Teilnehmer importieren', prefixIcon: 'e-icon-upload', id: 'importRecords' },
        { text: 'Export', tooltipText: 'Teilnehmerdaten exportieren', prefixIcon: 'e-icon-export', id: 'exportRecords' },
        { type: 'Separator' },
        { text: 'Anmeldeformular', tooltipText: 'Anmeldeformular öffnen', prefixIcon: 'e-icon-text-form', id: 'signupLink' },
        'Search'
      ],
      filterOptions: {
        type: 'Menu'
      },
      filter: {
        type: 'CheckBox'
      },
      editorToolbar: [
        ["bold", "italic", "underline"]
      ],
      sortSettings: {
        columns: [
          {
            field: 'company',
            direction: 'Ascending'
          },
          {
            field: 'confirmed_date',
            direction: 'Descending'
          }
        ]
      },
      groupSettings: { 
        captionTemplate: "<div>${format(data)}</div>",
        columns: []
      },
      editSettings: {
        allowEditing: true,
        allowAdding: true,
        allowDeleting: true,
        allowEditOnDblClick: false
      },
      selectionOptions: {
        checkboxMode: 'Default'
      },
      labelColumnAttributes : {
        class: 'label-column'
      },
      statusColumnAttributes : {
        class: 'status-column'
      }
    }
  },
  created() {
    bus.$on('eventChange', this.eventChange)
  },
  beforeDestroy() {
    bus.$off('eventChange', this.eventChange)
  },
  mounted: function() {
    document.getElementById(this.$refs.grid.ej2Instances.element.id + '_searchbar').addEventListener('keyup', () => {
      this.$refs.grid.search((event.target).value)
    })
    document.getElementById(this.$refs.grid.ej2Instances.element.id + '_searchbar').addEventListener('click', () => {
      this.$refs.grid.ej2Instances.searchSettings.key = '';
    })
    if (localStorage.eventCategory) {
      this.eventCategory = localStorage.eventCategory
    }
    if (localStorage.eventYear) {
      this.eventYear = localStorage.eventYear
    }
    if (localStorage.event) {
      this.event = localStorage.event
    }
    this.resetModel()
    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['editRecord'], false)
    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['deleteRecord'], false)
    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['segmentRecord'], false)
    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['consultRecord'], false)
    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['notifyRecords'], false)
    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['registerRecords'], false)
    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['printAuthorization'], false)
    this.$refs.grid.ej2Instances.toolbarModule.enableItems(['transferRecords'], false)
  },
  computed: {
    exportAction() {
      return this.action.export;
    },
    activeRecordsChange() {
      return this.activeRecords.scope;
    },
    activeRecordsProgress() {
      if (this.activeRecords.total !== 0) {
        return (this.activeRecords.processed / this.activeRecords.total) * 100
      } else {
        return 0
      }
    }
  },
  watch: {
    selectedRecords: {
      handler: function () {
        if (this.selectedRecords.length === 0) {
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['deleteRecord'], false)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['segmentRecord'], false)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['consultRecord'], false)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['notifyRecords'], false)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['registerRecords'], false)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['printAuthorization'], false)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['transferRecords'], false)
        } else {
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['deleteRecord'], true)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['segmentRecord'], true)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['consultRecord'], true)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['notifyRecords'], true)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['registerRecords'], true)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['printAuthorization'], true)
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['transferRecords'], true)
        }
        if (this.selectedRecords.length === 1) {
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['editRecord'], true)
        } else {
          this.$refs.grid.ej2Instances.toolbarModule.enableItems(['editRecord'], false)
        }
      },
      deep: true
    },
    activeRecordsChange: {
      handler: function () {
        this.setActiveRecords(this.activeRecords.scope)
      },
      deep: true
    },
    exportAction: {
      handler: function () {
        axios.get('get_export_count.php?action=' + this.action.export).then(response => {
          this.exportRecordCount = response.data
        })
      }
    }
  },
  methods: {
    eventChange: function () {
      this.$refs.grid.refresh()
    },
    dataBound: function () {
      this.$refs.grid.autoFitColumns(['reference', 'segment', 'consultant'])
    },
    actionComplete: function (e) {
      if (e.requestType === 'grouping' || e.requestType === 'searchingss') {
        this.$refs.grid.ej2Instances.groupModule.collapseAll()
        //console.log(this.groupSettings.columns)
      }
    },
    queryCellInfo: function (args) {
      if (args.column.field === 'invited') {
        if (args.data['invited'] === 1) {
          args.cell.classList.add('status-circle', 'status-grey')
        } else if (args.data['invited'] === 2) {
          args.cell.classList.add('status-circle', 'status-green')
        } else if (args.data['invited'] === 3) {
          args.cell.classList.add('status-circle', 'status-blue')
        } else if (args.data['invited'] === 4) {
          args.cell.classList.add('status-circle', 'status-yellow')
        } else if (args.data['invited'] === 5) {
          args.cell.classList.add('status-circle', 'status-red')
        }
        args.cell.textContent = ''
      }

      if (args.column.field === 'confirmed') {
        if (args.data['confirmed'] === 1) {
          args.cell.classList.add('status-circle', 'status-grey')
        } else if (args.data['confirmed'] === 2) {
          args.cell.classList.add('status-circle', 'status-green')
        } else if (args.data['confirmed'] === 3) {
          args.cell.classList.add('status-circle', 'status-red')
        }
        args.cell.textContent = ''
      }

      if (args.column.field === 'authorized') {
        if (args.data['authorized'] === 1 && args.data['confirmed'] === 3) {
          args.cell.classList.add('status-circle', 'status-red')
        } else if (args.data['authorized'] === 1) {
          args.cell.classList.add('status-circle', 'status-grey')
        } else if (args.data['authorized'] === 2) {
          args.cell.classList.add('status-circle', 'status-green')
        }
        args.cell.textContent = ''
      }

      if (args.column.field === 'notification') {
        if (args.data['notification'] === 1) {
          args.cell.classList.add('status-circle', 'status-grey')
        } else if (args.data['notification'] === 2) {
          args.cell.classList.add('status-circle', 'status-green')
        }
        args.cell.textContent = ''
      }

      if (args.column.field === 'visited') {
        if (args.data['visited'] === 1) {
          args.cell.classList.add('status-circle', 'status-grey')
        } else if (args.data['visited'] === 2) {
          args.cell.classList.add('status-circle', 'status-green')
        }
        args.cell.textContent = ''
      }
    },
    clickToolbar: function (args) {
      if (args.item.id === 'addRecord') {
        if (this.selectedRecords.length > 0) {
          axios.get('get_participant.php?id=' + this.selectedRecords[0].id).then(response => {
            this.model.company = response.data.company
            this.model.street = response.data.street
            this.model.zip = response.data.zip
            this.model.city = response.data.city
            this.model.region = response.data.region
            this.model.country = response.data.country
            this.model.segment = response.data.segment
            this.model.consultant = response.data.consultant
            this.model.notification = response.data.notification
            this.showModal = true
            this.modalEdit = false
          })
        } else {
          this.showModal = true
          this.modalEdit = false
        }
      }
      if (args.item.id === 'editRecord') {
        axios.get('get_participant.php?id=' + this.selectedRecords[0].id).then(response => {
          this.model = response.data
          this.showModal = true
          this.modalEdit = true
        })
      }
      if (args.item.id === 'deleteRecord') {
        this.action.selection = []
        for (var i = 0; i < this.selectedRecords.length; i++) {
          this.action.selection.push(this.selectedRecords[i].id)
        }
        this.showDelete = true
      }
      if (args.item.id === 'segmentRecord') {
        this.action.selection = []
        for (i = 0; i < this.selectedRecords.length; i++) {
          this.action.selection.push(this.selectedRecords[i].id)
        }
        this.showSegment = true
      }
      if (args.item.id === 'consultRecord') {
        this.action.selection = []
        for (i = 0; i < this.selectedRecords.length; i++) {
          this.action.selection.push(this.selectedRecords[i].id)
        }
        this.showConsultant = true
      }
      if (args.item.id === 'notifyRecords') {
        this.action.selection = []
        for (i = 0; i < this.selectedRecords.length; i++) {
          this.action.selection.push(this.selectedRecords[i].id)
        }
        this.showNotifyRecords = true
      }
      if (args.item.id === 'inviteRecords') {
        this.activeRecords.endpoint = 'send_invitations_v2'
        if (this.selectedRecords.length === 0) {
          this.activeRecords.scope = 'pending_invitation'
          this.setActiveRecords('pending_invitation')
        } else {
          this.activeRecords.scope = 'selection'
          this.setActiveRecords('selection')
        }
        this.showInviteRecords = true
      }
      if (args.item.id === 'registerRecords') {
        this.action.selection = []
        for (i = 0; i < this.selectedRecords.length; i++) {
          this.action.selection.push(this.selectedRecords[i].id)
        }
        this.showRegisterRecords = true
      }
      if (args.item.id === 'authorizeRecords') {
        this.activeRecords.endpoint = 'send_tickets_v2'
        if (this.selectedRecords.length === 0) {
          this.activeRecords.scope = 'pending_authorization'
          this.setActiveRecords('pending_authorization')
        } else {
          this.activeRecords.scope = 'selection'
          this.setActiveRecords('selection')
        }
        this.showAuthorizeRecords = true
      }
      if (args.item.id === 'printAuthorization') {
        this.action.selection = []
        for (i = 0; i < this.selectedRecords.length; i++) {
          this.action.selection.push(this.selectedRecords[i].id)
        }
        this.showPrintAuthorization = true
      }
      if (args.item.id === 'transferRecords') {
        this.action.selection = []
        for (i = 0; i < this.selectedRecords.length; i++) {
          this.action.selection.push(this.selectedRecords[i].id)
        }
        this.showTransferRecords = true
      }
      if (args.item.id === 'importRecords') {
        this.showImportRecords = true
      }
      if (args.item.id === 'exportRecords') {
        this.showExportRecords = true
      }
      if (args.item.id === 'signupLink') {
        var url = Vue.prototype.$serverUrl + 'anmeldung/?category=' + this.eventCategory + '&preselect=' + this.event + '&account=' + this.username
        window.open(url, '_blank', 'noreferrer');
      }
    },
    onRowSelected: function() {
      this.selectedRecords = this.$refs.grid.getSelectedRecords()
    },
    onRowDeselected: function() {
      this.selectedRecords = this.$refs.grid.getSelectedRecords()
    },
    recordDoubleClick: function(row) {
      clearSelection()
      this.$refs.grid.clearRowSelection()
      this.$refs.grid.selectRow(row.rowIndex)
      axios.get('get_participant.php?id=' + row.rowData.id).then(response => {
        this.model = response.data
        this.showModal = true
        this.modalEdit = true
      })
    },
    resetActiveRecords: function() {
      this.activeRecords.selection = []
      this.activeRecords.selected = 0
      this.activeRecords.total = 0
      this.activeRecords.processed = 0
      this.activeRecords.failed = []
      this.activeRecords.complete = false
    },
    setActiveRecords: function(scope) {
      this.resetActiveRecords()
      if (this.activeRecords.scope === 'selection') {
        for (const record of this.selectedRecords){
          this.activeRecords.selection.push(record.id)
        }
        this.activeRecords.total = this.activeRecords.selection.length
      } else {
        axios.get('count_records.php?model=' + this.activeRecords.model + '&scope=' + scope + '&target=' + this.activeRecords.target).then(response => {
          this.activeRecords.selection = response.data.selection
          this.activeRecords.total = response.data.total
        })
      }
    },
    closeModal () {
      this.showModal = false
      this.resetModel()
      //this.$refs.grid.clearRowSelection()
    },
    saveModal(event) {
      this.wasValidated = true
      event.target.classList.add('was-validated')
      if (this.model.company !== '' && this.model.title !== '' && this.model.first_name !== '' && this.model.last_name !== '' && this.model.email !== '') {
        this.loading = true
        var url = ''
        if (this.modalEdit === true) {
          url = 'edit_participant.php'
        } else {
          url = 'add_participant.php'
        }
        axios({
          method: 'post',
          url: url,
          data: this.model
        }).then(response => {
          this.loading = false
          if (response.data.success === false) {
            alert(response.data.error)
          } else {
            if (this.modalEdit === true) {
              var rowIndex = this.$refs.grid.getRowIndexByPrimaryKey(this.model.id)
              this.$refs.grid.updateRow(rowIndex, this.model)
            } else {
              this.$refs.grid.refresh()
            }
            this.showModal = false
            this.resetModel()
            //this.$refs.grid.clearRowSelection()
          }
        }).catch(error => {
          this.loading = false
          alert('Die Verbindung konnte nicht hergestellt werden oder wurde unterbrochen. Bitte versuchen Sie es später erneut (' + error.message + ')')
        })
      }
    },
    deleteRecord () {
      this.loading = true
      var url = 'delete_participant.php'
      axios({
        method: 'post',
        url: url,
        data: this.action.selection
      }).then(response => {
        this.loading = false
        if (response.data.success === false) {
          alert(response.data.error)
        } else {
          this.$refs.grid.refresh()
          this.showDelete = false
        }
      }).catch(error => {
        this.loading = false
        alert('Die Verbindung konnte nicht hergestellt werden oder wurde unterbrochen. Bitte versuchen Sie es später erneut (' + error.message + ')')
      })
    },
    segmentEntry () {
      this.loading = true
      var url = 'segment_participant.php'
      const payload = {
        ids: this.action.selection,
        segment: this.model.segment
      }
      axios({
        method: 'post',
        url: url,
        data: payload
      }).then(response => {
        this.loading = false
        if (response.data.success === false) {
          alert(response.data.error)
        } else {
          this.$refs.grid.refresh()
          this.showSegment = false
          this.resetModel()
        }
      }).catch(error => {
        this.loading = false
        alert('Die Verbindung konnte nicht hergestellt werden oder wurde unterbrochen. Bitte versuchen Sie es später erneut (' + error.message + ')')
      })
    },
    consultEntry () {
      this.loading = true
      var url = 'consult_participant.php'
      const payload = {
        ids: this.action.selection,
        consultant: this.model.consultant
      }
      axios({
        method: 'post',
        url: url,
        data: payload
      }).then(response => {
        this.loading = false
        if (response.data.success === false) {
          alert(response.data.error)
        } else {
          this.$refs.grid.refresh()
          this.showConsultant = false
          this.resetModel()
        }
      }).catch(error => {
        this.loading = false
        alert('Die Verbindung konnte nicht hergestellt werden oder wurde unterbrochen. Bitte versuchen Sie es später erneut (' + error.message + ')')
      })
    },
    notifyRecords () {
      this.loading = true
      var url = 'notify_participant.php'
      const payload = {
        ids: this.action.selection,
        notification: this.model.notification
      }
      axios({
        method: 'post',
        url: url,
        data: payload
      }).then(response => {
        this.loading = false
        if (response.data.success === false) {
          alert(response.data.error)
        } else {
          this.$refs.grid.refresh()
          this.showNotifyRecords = false
          this.resetModel()
        }
      }).catch(error => {
        this.loading = false
        alert('Die Verbindung konnte nicht hergestellt werden oder wurde unterbrochen. Bitte versuchen Sie es später erneut (' + error.message + ')')
      })
    },
    exportRecordsShown () {
      axios.get('get_export_count.php?action=' + this.action.export).then(response => {
        this.exportRecordCount = response.data
      })
    },
    async processRecords () {
      this.loading = true
      for (const record of this.activeRecords.selection) {
        this.activeRecords.selected = record
        await this.queryRecord()
      }
      this.activeRecords.complete = true
      this.loading = false
      this.$refs.grid.refresh()
      this.$refs.grid.clearRowSelection()
    },
    async queryRecord () {
      await axios({
        method: 'post',
        url: this.activeRecords.endpoint + '.php',
        data: this.activeRecords
      }).then(response => {
        if (response.data.success === false) {
          this.activeRecords.failed.push(response.data.failed)
          this.activeRecords.processed++
        } else {
          this.activeRecords.processed++
        }
      }).catch(error => {
        alert('Die Verbindung konnte nicht hergestellt werden oder wurde unterbrochen. Bitte versuchen Sie es später erneut (' + error.message + ')')
      })
    },
    registerRecords () {
      this.loading = true
      var url = 'register_participant.php'
      const payload = {
        ids: this.action.selection,
        action: this.action.register
      }
      axios({
        method: 'post',
        url: url,
        data: payload
      }).then(response => {
        this.loading = false
        if (response.data.success === false) {
          alert(response.data.error)
        } else {
          this.$refs.grid.refresh()
          this.showRegisterRecords = false
          this.resetModel()
        }
      }).catch(error => {
        this.loading = false
        alert('Die Verbindung konnte nicht hergestellt werden oder wurde unterbrochen. Bitte versuchen Sie es später erneut (' + error.message + ')')
      })
    },
    printAuthorization () {
      var ids = ''
      this.selectedRecords.forEach(function (item) {
        ids += item.id + ','
      })
      ids = ids.slice(0, -1)
      var url = Vue.prototype.$serverUrl + 'api/print_authorization.php?id=' + ids
      window.open(url)
      setTimeout(() => {
        this.$refs.grid.refresh()
        this.showPrintAuthorization = false
        this.resetModel()
      }, 3000);
    },
    transferRecords () {
      this.loading = true
      var url = 'transfer_participant.php'
      const payload = {
        ids: this.action.selection,
        action: this.action.eventLocationOptions
      }
      axios({
        method: 'post',
        url: url,
        data: payload
      }).then(response => {
        this.loading = false
        if (response.data.success === false) {
          alert(response.data.error)
        } else {
          this.$refs.grid.refresh()
          this.showTransferRecords = false
          this.resetModel()
        }
      }).catch(error => {
        this.loading = false
        alert('Die Verbindung konnte nicht hergestellt werden oder wurde unterbrochen. Bitte versuchen Sie es später erneut (' + error.message + ')')
      })
    },
    getEventCategoryValue(value) {
      if (value !== this.eventCategory) {
        this.eventCategory = value
        axios.post('select_events.php', {
          eventCategory: value,
          eventYear: this.eventYear,
          event: this.event
        }).then(response => {
          this.action.eventCategoryOptions = response.data.eventCategoryOptions
          this.action.eventYearOptions = response.data.eventYearOptions
          this.action.eventLocationOptions = response.data.eventLocationOptions
        })
      }
    },
    getEventYearValue(value) {
      if (value !== this.eventYear) {
        this.eventYear = value
        axios.post('select_events.php', {
          eventCategory: this.eventCategory,
          eventYear: value,
          event: this.event
        }).then(response => {
          this.action.eventCategoryOptions = response.data.eventCategoryOptions
          this.action.eventYearOptions = response.data.eventYearOptions
          this.action.eventLocationOptions = response.data.eventLocationOptions
        })
      }
    },
    handleFileUpload( event ) {
      this.file = event.target.files[0]
    },
    importRecords () {
      this.loading = true
      let formData = new FormData()
      formData.append('file', this.file)
      axios.post( 'import_participants.php',
        formData,
        {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      }).then(response => {
        this.loading = false
        if (response.data.success === false) {
          alert(response.data.error)
        } else {
          this.$refs.grid.refresh()
          this.showImportRecords = false
        }
      }).catch(error => {
        this.loading = false
        alert('Die Verbindung konnte nicht hergestellt werden oder wurde unterbrochen. Bitte versuchen Sie es später erneut (' + error.message + ')')
      })
    },
    exportRecords () {
      var url = Vue.prototype.$serverUrl + 'api/export_participants.php?action=' + this.action.export
      window.open(url)
    },
    resetModel () {
      this.wasValidated = false
      this.model.id = 'new'
      this.model.timeslot = []
      axios.get('list_timeslots.php').then(response => {
        this.model.timeslot = response.data
      })
      this.model.consultant = []
      axios.get('list_consultants.php').then(response => {
        this.model.consultant = response.data
      })
      axios.get('get_export_count.php?action=' + this.action.export).then(response => {
        this.exportRecordCount = response.data
      })
      this.model.notification = ''
      this.model.reference = ''
      this.model.segment = []
      axios.get('list_segments.php').then(response => {
        this.model.segment = response.data
      })
      this.model.memo = ''
      this.model.company = ''
      this.model.title = [
        { text: 'Herr', value: 'Herr', selected: true },
        { text: 'Frau', value: 'Frau', selected: false }
      ]
      this.model.title_honorific = ''
      this.model.first_name = ''
      this.model.last_name = ''
      this.model.street = ''
      this.model.zip = ''
      this.model.city = ''
      this.model.region = ''
      this.model.country = ''
      this.model.phone = ''
      this.model.mobile = ''
      this.model.fax = ''
      this.model.email = ''

      axios.post('select_events.php', {
        eventCategory: this.eventCategory,
        eventYear: this.eventYear,
        event: this.event
      }).then(response => {
        this.action.eventCategoryOptions = response.data.eventCategoryOptions
        this.action.eventYearOptions = response.data.eventYearOptions
        this.action.eventLocationOptions = response.data.eventLocationOptions
      })
    }
  },
  provide: {
    grid: [Edit, Toolbar, Resize, Search, Sort, Group]
  }
}
window.format = function(value) {
  var x = value.count
  if (x > 1) {
    x = value.count + ' Einträge'
  } else {
    x = value.count + ' Eintrag'
  }
  switch (value.field) {
    case 'test':
      return value.key + ' ' + x
    default:
      // return value.field + ': ' + value.key + ' ' + x
      return value.key + ' <span class="grey-text">(' + x + ')</span>'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.e-grid .e-rowcell.label-column {
  font-weight: normal;
  font-size: 13px;
}

.e-grid .status-column {
  padding-right: 0px !important;
  padding-left: 10px !important;
}

.padding-label label {
  margin-bottom: 0px;
  margin-top: 14px;
}

.select-wrapper {
  position: relative;
  top: -8px;
}

.custom2 .select-wrapper {
  top: -24px;
}

.custom3 .select-wrapper {
  top: -24px;
}

.row .col-md-3 {
  height: 75px !important;
}

#memoEditor {
  height: 100px;
}

.modal-without-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
  pointer-events: initial !important;
}

.e-search-icon {
  font-size: 20px !important;
}

.e-grid .e-toolbar-items .e-toolbar-item.e-search-wrapper .e-search {
  width: 295px !important;
}

.e-search input {
  font-size: 17px !important;
}

.table-header-icon {
  font-size: 14px !important;
}

.status-column .e-headercelldiv {
  padding-top: 3px !important;
  padding-left: 4px !important;
}

.status-column:last-child .e-headercelldiv {
  padding-top: 1px !important;
  padding-left: 7px !important;
  color: #1976d2;
}
</style>
